module.exports = __webpack_public_path__ + "static/covid-badge-75f262ca6599b1cd55f6f64299a6b445.png";